/* Inline icons for the boards home (kept local to avoid polaris-icon name churn). */
interface IconProps {
  className?: string;
  filled?: boolean;
}

export const StarIcon = ({ className, filled }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M10 2.5l2.35 4.76 5.25.76-3.8 3.7.9 5.23L10 14.96l-4.7 2.47.9-5.23-3.8-3.7 5.25-.76L10 2.5z" />
  </svg>
);

export const PinIcon = ({ className, filled }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M12.5 2.5l5 5-2.5 1-2.5 3.5-1 1-5-5 1-1L11 4.5l1.5-2z" />
    <path d="M7 13l-3.5 3.5" />
  </svg>
);

export const ChevronIcon = ({ className }: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" className={className} aria-hidden="true">
    <path d="M5.5 7.5L10 12l4.5-4.5" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GridIcon = ({ className }: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" className={className} aria-hidden="true">
    <rect x="3" y="3" width="6" height="6" rx="1" />
    <rect x="11" y="3" width="6" height="6" rx="1" />
    <rect x="3" y="11" width="6" height="6" rx="1" />
    <rect x="11" y="11" width="6" height="6" rx="1" />
  </svg>
);

export const ListIcon = ({ className }: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" className={className} aria-hidden="true">
    <rect x="3" y="4" width="14" height="2.5" rx="1" />
    <rect x="3" y="8.75" width="14" height="2.5" rx="1" />
    <rect x="3" y="13.5" width="14" height="2.5" rx="1" />
  </svg>
);

export const SearchIcon = ({ className }: IconProps) => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" className={className} aria-hidden="true">
    <circle cx="9" cy="9" r="6" />
    <path d="M17 17l-3.5-3.5" strokeLinecap="round" />
  </svg>
);

export const ClockIcon = ({ className }: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" className={className} aria-hidden="true">
    <circle cx="10" cy="10" r="7" />
    <path d="M10 6v4l3 2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
